import object from 'helpers/object'
// import getCityName from 'helpers/getCityName'


// const currentCity = (window && window.location && getCityName({ host: window.location.host })) || ''

export const initialState = {
  category: null,
  area: null,
  areas: [],
  tool: null,
  toolType: null,
  tools: [],
  nomenclature: [],
  categories: [
    {
      id: 'sport',
      title: 'Спорт и досуг',
    },
    {
      id: 'edu',
      title: 'Образование',
    },
    // ...(((window && window.location && getCityName({ host: window.location.host })) || '') === 'sarov' ? [{
    //   id: 'rpc',
    //   title: 'Православная гимназия',
    // }] : []),
    // {
    //   id: 'culture',
    //   title: 'Культура',
    // },
    // {
    //   id: 'med',
    //   title: 'Медицина',
    // },
  ],
  // isActive: false,
  isWelcomeHidden: false,
  isFetched: false,
}


// export const setActive = (state, payload) => (
//   object.setIn(state, [ 'isActive' ], payload)
// )

export const setWelcomeHidden = (state, payload) => (
  object.setIn(state, [ 'isWelcomeHidden' ], payload)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const setCategory = (state, payload) => (
  object.setIn(state, [ 'category' ], payload)
)

export const setArea = (state, payload) => (
  object.setIn(state, [ 'area' ], payload)
)

export const setTool = (state, payload) => (
  object.setIn(state, [ 'tool' ], payload)
)

export const setToolType = (state, payload) => (
  object.setIn(state, [ 'toolType' ], payload)
)

export const setTools = (state, payload) => (
  object.setIn(state, [ 'tools' ], payload)
)

export const setNomenclature = (state, payload) => (
  object.setIn(state, [ 'nomenclature' ], payload)
)

export const setRpcNomenclature = (state, payload) => (
  object.setIn(state, [ 'rpcNomenclature' ], payload)
)

export const setAreas = (state, payload) => (
  object.setIn(state, [ 'areas' ], payload)
)

export const setFetched = (state, payload) => (
  object.setIn(state, [ 'isFetched' ], payload)
)
